import { cva, type VariantProps } from 'class-variance-authority';

/**
 * Surface tokens for Radix/Base UI overlays that portal to `document.body`.
 * Both variants set an opaque background — required because portaled nodes sit
 * outside the dialog and do not inherit its surface color.
 */
export const portaledSurfaceVariants = cva('', {
  variants: {
    variant: {
      light: 'border-border-muted bg-background-surface text-foreground-primary',
      dark: 'dark border-border-muted bg-background-surface text-foreground-primary [color-scheme:dark]',
    },
  },
  defaultVariants: {
    variant: 'light',
  },
});

export type PortaledSurfaceVariant = NonNullable<
  VariantProps<typeof portaledSurfaceVariants>['variant']
>;
